import { render, staticRenderFns } from "./Paymentmethod.vue?vue&type=template&id=68616130"
import script from "./Paymentmethod.vue?vue&type=script&lang=js"
export * from "./Paymentmethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68616130')) {
      api.createRecord('68616130', component.options)
    } else {
      api.reload('68616130', component.options)
    }
    module.hot.accept("./Paymentmethod.vue?vue&type=template&id=68616130", function () {
      api.rerender('68616130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vendor/firegroup/fire-core-formgenerator/src/assets/vue/frontend/elements/Paymentmethod.vue"
export default component.exports